module.exports = __webpack_public_path__ + "static/media/ucc.df190a4e.png";